export function hasPublishedCustomMenu(
  business: { menu_public_slug: string | null; menu_published: boolean } | null,
): boolean {
  return Boolean(business?.menu_published && business.menu_public_slug?.trim());
}
